import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/pro-light-svg-icons';

export function CommentIcon({ color = '' }) {
  const styleObj: React.CSSProperties = color ? { color } : {};
  return <FontAwesomeIcon style={styleObj} icon={faComment} size="xs" />;
}
